import axios from './api';

export default {
	getCurrencies: async () => {
		return await axios.get().get('/system/currencies');
	}
};
